<ul>
    <li>Id: {{contact?.id}}</li>
    <li>type: {{contact?.type}}</li>
    <li>name: {{contact?.name}}</li>
    <li>phoneNumber: {{contact?.phoneNumber}}</li>
    <li>prefix: {{contact?.prefix}}</li>
    <li>extension: {{contact?.extension}}</li>
    <li>endpointARN: {{contact?.endpointARN}}</li>
    <li>queue: {{contact?.queue}}</li>
    <li>availability: {{contact?.availability}}</li>
    <li>recordId: {{contact?.recordId}}</li>
    <li>description: {{contact?.description}}</li>
    <li>queueWaitTime: {{contact?.queueWaitTime}}</li>
</ul>